import AppContent from '@/components/AppContent.jsx';
import AppFooter from '@/components/AppFooter.jsx';
import AppHeader from '@/components/AppHeader.jsx';
import AppSidebar from '@/components/AppSidebar.jsx';

import { useTheme } from '@/context/theme/UseTheme.jsx';

const DefaultLayout = () => {
    const theme = useTheme();

    return (
        <div style={theme.vars}>
            <AppSidebar />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <AppHeader />
                <div className="body flex-grow-1 px-3">
                    <AppContent />
                </div>
                <AppFooter />
            </div>
        </div>
    );
};

export default DefaultLayout;
